import {
  ChangeDetectorRef,
  Directive,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  SimpleChanges,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';

@Directive({
  selector: '[appHideOnRoute]',
})
export class HideOnRouteDirective implements OnDestroy, OnChanges {
  private router = inject(Router);
  private templateRef = inject(TemplateRef<unknown>);
  private viewContainer = inject(ViewContainerRef);
  private cdr = inject(ChangeDetectorRef);

  @Input('appHideOnRoute') public hideRoutes: string[] = [];
  private destroy$ = new Subject<void>();

  constructor() {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this.destroy$)
      )
      .subscribe((event: NavigationEnd) => {
        this.updateView(event.url);
      });
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes) {
      this.updateView(this.router.url);
    }
  }

  private updateView(url: string): void {
    const shouldHide = this.hideRoutes.some((route) => url?.includes(route));
    if (shouldHide) {
      this.viewContainer.clear();
    } else {
      if (this.viewContainer.length === 0) {
        this.viewContainer.createEmbeddedView(this.templateRef);
      }
    }
    this.cdr.detectChanges();
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
